import { useContext, useState } from 'react';
import ModalInfo from '../components/Modals/ModalInfo';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { createContext } = require('react');

const ModalInfoContext = createContext({});

export default function ModalInfoProvider({ children }) {
  const [isOpenModalInfo, setIsOpenModalInfo] = useState(false);
  const [modalInfoProps, setModalInfoProps] = useState({
    title: '',
    description: '',
  });

  const renderModalInfo = () => {
    const config = {
      title: modalInfoProps.title,
      description: modalInfoProps.description,
      isOpen: isOpenModalInfo,
      handleClose: () => setIsOpenModalInfo(false),
    };

    return <ModalInfo {...config} />;
  };

  return (
    <ModalInfoContext.Provider value={{ setIsOpenModalInfo, setModalInfoProps }}>
      {renderModalInfo()}
      {children}
    </ModalInfoContext.Provider>
  );
}

export function useModalInfo() {
  return useContext(ModalInfoContext);
}
